import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { Tooltip } from "@/components/Common/Tooltip";
import { useInboxPanel } from "@/hooks/useInboxPanel";
import { IconNames } from "@/types/v2";
import { ICON_ONLY_HEADER_LINKS } from "@/lib/const";
import { CustomerUpdatesBadgeCount } from "@/components/CustomerUpdate/CustomerUpdatesBadgeCount";
import { useCustomerUpdates } from "@/hooks/useCustomerUpdates";

export const InboxTrigger = () => {
  const { isOpen, togglePanel } = useInboxPanel();
  const { isCustomerUpdatesEnabled } = useCustomerUpdates();

  return (
    <Button
      className="relative rounded-md text-base hover:bg-slate-200"
      variant="ghost-primary"
      size={ICON_ONLY_HEADER_LINKS ? "lgIcon" : "default"}
      onClick={togglePanel}
      aria-expanded={isOpen}
      aria-controls="inbox-panel"
    >
      <Tooltip message="Right Panel" asChild={false}>
        <Icon
          name={isOpen ? IconNames.panelRightClose : IconNames.panelRight}
          className="cursor-pointer hover:opacity-70"
          size={20}
        />
      </Tooltip>
      {isCustomerUpdatesEnabled && (
        <>{isOpen ? null : <CustomerUpdatesBadgeCount />}</>
      )}
    </Button>
  );
};
